// useAgentChatGate — gate de la feature del chat de soporte Paulina (AGENT_CHAT_FEATURE_KEY),
// instancia del contrato `FeatureGate` (ver useFeatureGate.ts). Una sola definición; todas las
// superficies que decidan montar/ofrecer Paulina consumen este hook.
//
//   - `offered`: el comercio TIENE Paulina (treatment o GA con flag de build) → se monta el chat.
//     Con el build-flag 'agent-chat' AUSENTE (prod hoy) el hook queda inerte y `offered` es false;
//     por eso el montaje en Layout sólo depende de este gate cuando ENABLE_AGENT_CHAT_ROLLOUT está
//     ON (ver PaulinaGate en Layout.tsx). Flag OFF = Paulina para todos (estado actual).

import { makeFeatureGateHook } from '@hooks/useFeatureGate';
import { AGENT_CHAT_FEATURE_KEY } from '@utils/featureRollout/constants';

export const useAgentChatGate = makeFeatureGateHook({
  featureKey: AGENT_CHAT_FEATURE_KEY,
  inviteTrigger: 'agent_chat',
});
